import React from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import * as Fi from 'react-icons/fi'

const PricingCard = ({ plan, isPopular }) => {
  const handlePayment = () => {
    window.open(plan.paymentLink, '_blank')
  }

  const formatPrice = (amount) => {
    return `$${amount}`
  }

  const getBillingText = (interval) => {
    if (interval === 'month') return '/月'
    return ''
  }

  return (
    <div className={`relative p-6 rounded-2xl border transition-all hover:scale-105 ${
      isPopular 
        ? 'bg-gradient-to-br from-indigo-500/20 to-purple-600/20 border-indigo-400/50 shadow-lg shadow-indigo-500/25'
        : 'bg-white/[0.05] border-white/10 hover:bg-white/[0.08]'
    }`}>
      {isPopular && (
        <div className="absolute -top-3 left-1/2 -translate-x-1/2">
          <span className="bg-indigo-500 text-white text-xs font-black px-3 py-1 rounded-full">
            熱門選擇
          </span>
        </div>
      )}

      <div className="text-center mb-6">
        <div className="text-3xl font-black text-white mb-2">
          {formatPrice(plan.amount)}
          <span className="text-lg text-white/60 font-bold">
            {getBillingText(plan.interval)}
          </span>
        </div>
        <p className="text-white/70 text-sm font-bold">
          {plan.interval ? '贊助訂閱' : '單次贊助'}
        </p>
      </div>

      <div className="space-y-3 mb-6">
        <div className="flex items-center gap-3">
          <Fi.FiCheck className="text-emerald-400 text-lg shrink-0" />
          <span className="text-white/80 text-sm">支持應用開發</span>
        </div>
        <div className="flex items-center gap-3">
          <Fi.FiCheck className="text-emerald-400 text-lg shrink-0" />
          <span className="text-white/80 text-sm">無廣告體驗</span>
        </div>
        <div className="flex items-center gap-3">
          <Fi.FiCheck className="text-emerald-400 text-lg shrink-0" />
          <span className="text-white/80 text-sm">優先技術支援</span>
        </div>
        {plan.interval && (
          <div className="flex items-center gap-3">
            <Fi.FiCheck className="text-emerald-400 text-lg shrink-0" />
            <span className="text-white/80 text-sm">隨時可取消</span>
          </div>
        )}
      </div>

      <button
        onClick={handlePayment}
        className={`w-full py-3.5 rounded-xl font-black text-sm transition-all active:scale-95 ${
          isPopular
            ? 'bg-indigo-500 hover:bg-indigo-400 text-white shadow-lg shadow-indigo-500/30'
            : 'bg-white/10 hover:bg-white/20 text-white border border-white/20'
        }`}
      >
        {plan.interval ? '開始贊助' : '單次贊助'}
      </button>
    </div>
  )
}

const PricingModal = ({ open, onClose }) => {
  const pricingPlans = [
    {
      name: "Badminton Scorer Subscription Sponsor",
      amount: 5,
      priceId: "price_1T7ZmQIEnneB4h0mUxOoW4Ls",
      paymentLink: "https://buy.stripe.com/dRm6oI2av4OFa1N6mu0Fi16",
      currency: "usd",
      interval: "month"
    },
    {
      name: "Badminton Scorer Subscription Sponsor",
      amount: 8,
      priceId: "price_1T7ZmQIEnneB4h0mSn9jRtx0",
      paymentLink: "https://buy.stripe.com/3cIeVe2av0ypa1N8uC0Fi14",
      currency: "usd",
      interval: "month"
    },
    {
      name: "Badminton Scorer Subscription Sponsor",
      amount: 10,
      priceId: "price_1T7ZmQIEnneB4h0mIT1GHZoJ",
      paymentLink: "https://buy.stripe.com/5kQ14o6qL3KBddZ26e0Fi12",
      currency: "usd",
      interval: "month"
    },
    {
      name: "Badminton Scorer Subscription Sponsor",
      amount: 5,
      priceId: "price_1T7ZmQIEnneB4h0mi2luTCjU",
      paymentLink: "https://buy.stripe.com/6oU3cw9CXftj6PB26e0Fi17",
      currency: "usd"
    },
    {
      name: "Badminton Scorer Subscription Sponsor",
      amount: 8,
      priceId: "price_1T7ZmQIEnneB4h0mJmltbBhF",
      paymentLink: "https://buy.stripe.com/cNifZi4iD1Ctb5R6mu0Fi15",
      currency: "usd"
    },
    {
      name: "Badminton Scorer Subscription Sponsor",
      amount: 10,
      priceId: "price_1T7ZmQIEnneB4h0mDOort5DO",
      paymentLink: "https://buy.stripe.com/fZueVe9CX3KB3DpcKS0Fi13",
      currency: "usd"
    }
  ]

  // Separate subscription and one-time plans
  const subscriptionPlans = pricingPlans.filter(plan => plan.interval === 'month')
  const oneTimePlans = pricingPlans.filter(plan => !plan.interval)

  return (
    <AnimatePresence>
      {open && (
        <div className="fixed inset-0 z-[250] flex items-center justify-center p-4">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="absolute inset-0 bg-slate-950/80 backdrop-blur-sm"
            onClick={onClose}
          />
          
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            transition={{ type: 'spring', damping: 25, stiffness: 300 }}
            className="relative z-10 w-full max-w-4xl max-h-[90vh] bg-[#0a1220] border border-white/10 rounded-3xl overflow-hidden shadow-2xl"
          >
            {/* Header */}
            <div className="px-6 py-5 border-b border-white/10 flex items-center justify-between">
              <div>
                <h2 className="text-2xl font-black text-white">支持羽球計分板</h2>
                <p className="text-white/60 text-sm mt-1">您的贊助讓我們持續改進這個免費應用</p>
              </div>
              <button
                onClick={onClose}
                className="text-white/60 hover:text-white bg-white/5 hover:bg-white/10 p-2 rounded-xl transition-colors"
              >
                <Fi.FiX className="text-xl" />
              </button>
            </div>

            {/* Content */}
            <div className="px-6 py-6 overflow-y-auto max-h-[calc(90vh-140px)]">
              {/* Monthly Subscriptions */}
              <div className="mb-8">
                <h3 className="text-lg font-black text-white mb-4 flex items-center gap-2">
                  <Fi.FiRefreshCw className="text-indigo-400" />
                  月度訂閱贊助
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  {subscriptionPlans.map((plan, index) => (
                    <PricingCard 
                      key={plan.priceId} 
                      plan={plan} 
                      isPopular={index === 1} 
                    />
                  ))}
                </div>
              </div>

              {/* One-time Payments */}
              <div>
                <h3 className="text-lg font-black text-white mb-4 flex items-center gap-2">
                  <Fi.FiHeart className="text-rose-400" />
                  單次贊助
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  {oneTimePlans.map((plan) => (
                    <PricingCard 
                      key={plan.priceId} 
                      plan={plan} 
                      isPopular={false} 
                    />
                  ))}
                </div>
              </div>

              {/* Footer Note */}
              <div className="mt-8 p-4 bg-white/[0.03] border border-white/10 rounded-xl">
                <div className="flex items-start gap-3">
                  <Fi.FiInfo className="text-blue-400 text-lg shrink-0 mt-0.5" />
                  <div>
                    <p className="text-white/80 text-sm font-bold mb-1">安全付款</p>
                    <p className="text-white/60 text-xs">
                      所有付款由 Stripe 安全處理。我們不會儲存您的付款資訊。
                      訂閱可隨時在 Stripe 客戶入口網站取消。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  )
}

export default PricingModal